﻿import { User } from 'oidc-client';
import { AuthenticatedUser } from '../../components/common/AuthenticatedComponent';

export type UserLogInfo = {
    companyId: string;
    companyName: string;
    companyRegion: string;
    username: string;
    sub: string;
    impersonatingUser: string | null;
};

export function getUserInfo(userData: AuthenticatedUser | User): UserLogInfo | null {
    const impersonatingUser = window.localStorage.getItem('impersonationuserid');
    return userData && userData.profile
        ? {
              companyId: userData.profile.companyId,
              companyName: userData.profile.companyName,
              companyRegion: userData.profile.companyRegion,
              username: userData.profile.username,
              sub: userData.profile.sub,
              impersonatingUser
          }
        : null;
}
